import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { INK, FONT } from './vizTokens';

/**
 * A titled surface. The heading carries what a single-series chart would
 * otherwise need a one-swatch legend to say.
 */
const Panel = ({ title, subtitle, action, children, alignSubtitle, sx }) => (
  <Paper
    elevation={0}
    sx={{
      border: `1px solid ${INK.border}`,
      borderRadius: '10px',
      p: { xs: 2, sm: 2.75 },
      height: '100%',
      backgroundColor: INK.surface,
      // Same reason: lets a wide child scroll rather than stretch the panel.
      minWidth: 0,
      overflow: 'hidden',
      ...sx,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: subtitle ? 0.5 : 2,
      }}
    >
      <Typography sx={{ ...FONT, fontSize: '15px', fontWeight: 600, color: INK.primary }}>
        {title}
      </Typography>
      {action}
    </Box>
    {/* `alignSubtitle` reserves two lines so panels sitting side by side start
        their charts on the same baseline even when one subtitle wraps and the
        other does not. */}
    {subtitle && (
      <Typography
        sx={{
          ...FONT,
          fontSize: '12.5px',
          color: INK.muted,
          mb: 2,
          lineHeight: 1.45,
          ...(alignSubtitle ? { minHeight: { md: '36px' } } : {}),
        }}
      >
        {subtitle}
      </Typography>
    )}
    {children}
  </Paper>
);

export default Panel;
